import { useEffect, useState } from "react";
import { MessageCircle, ArrowUp, X } from "lucide-react";
import { Link } from "react-router-dom";
import { WHATSAPP_LINK } from "../data/content";

export function WhatsAppFab() {
  return (
    <a
      data-testid="whatsapp-fab"
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-5 right-5 z-40 grid h-12 w-12 place-items-center rounded-full bg-zinc-950 text-white shadow-lg transition-transform duration-300 hover:-translate-y-0.5 hover:bg-zinc-800"
    >
      <MessageCircle className="h-5 w-5" />
    </a>
  );
}

export function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  if (!show) return null;
  return (
    <button
      data-testid="back-to-top"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Back to top"
      className="fixed bottom-20 right-5 z-40 grid h-10 w-10 place-items-center rounded-full border border-zinc-200 bg-white text-zinc-900 shadow-sm transition hover:bg-zinc-100"
    >
      <ArrowUp className="h-4 w-4" />
    </button>
  );
}

export function CookieConsent() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (typeof window === "undefined") return;
    const accepted = window.localStorage.getItem("rtd-cookie-consent");
    if (!accepted) setShow(true);
  }, []);
  if (!show) return null;
  const accept = () => {
    window.localStorage.setItem("rtd-cookie-consent", "accepted");
    setShow(false);
  };
  const decline = () => {
    window.localStorage.setItem("rtd-cookie-consent", "declined");
    setShow(false);
  };
  return (
    <div
      data-testid="cookie-consent"
      className="fixed bottom-4 left-4 right-4 z-40 mx-auto max-w-2xl rounded-2xl border border-zinc-200 bg-white p-4 shadow-xl sm:flex sm:items-center sm:gap-4"
    >
      <p className="flex-1 text-sm text-zinc-700">
        We use minimal cookies to improve your experience. By clicking &quot;Accept&quot;, you agree to our{" "}
        <Link to="/privacy" className="underline underline-offset-2 hover:text-zinc-950">Privacy Policy</Link>.
      </p>
      <div className="mt-3 flex items-center gap-2 sm:mt-0">
        <button
          data-testid="cookie-decline"
          onClick={decline}
          className="rounded-full border border-zinc-200 px-4 py-2 text-xs text-zinc-700 hover:bg-zinc-50"
        >
          Decline
        </button>
        <button
          data-testid="cookie-accept"
          onClick={accept}
          className="rounded-full bg-zinc-950 px-4 py-2 text-xs font-medium text-white hover:bg-zinc-800"
        >
          Accept
        </button>
        <button
          data-testid="cookie-close"
          onClick={decline}
          aria-label="Close cookie banner"
          className="grid h-8 w-8 place-items-center rounded-full text-zinc-500 hover:bg-zinc-100"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
